import { FacetOption } from './type';

type GetOptions = (phrase: string) => Promise<FacetOption[]>;

const getOptions = async (
  options: GetOptions | FacetOption[],
  phrase: string
): Promise<FacetOption[]> => {
  if (typeof options === 'function') {
    return options(phrase);
  }
  return options;
};

export const scoredSuggestions = (
  options: GetOptions | FacetOption[]
) => async (phrase = ''): Promise<FacetOption[]> => {
  const values = await getOptions(options, phrase);

  return values
    .map((option) => ({
      subject: option.label.toLowerCase(),
      option
    }))
    .map(({ subject, option }) => ({
      score: phrase
        .toLowerCase()
        .split(' ')
        .reduce((score, term) => {
          if (score < 0) {
            return score;
          }

          const index = subject.indexOf(term);

          if (index < 0) {
            return index;
          }

          return score + term.length / (index + 1) + subject.split(term).length;
        }, 0),
      option
    }))
    .filter((scored) => scored.score > 1)
    .sort((a, b) => b.score - a.score)
    .map((scored) => scored.option);
};
